export default (sport = null, seasonId = null) => store => next => action => {
  action.meta = {
    sport,
    seasonId,
    ...action.meta,
  };

  return next(action);
}
